import { render, staticRenderFns } from "./layout3.vue?vue&type=template&id=9d2c17f8&scoped=true"
import script from "./layout3.vue?vue&type=script&lang=js"
export * from "./layout3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d2c17f8",
  null
  
)

export default component.exports